var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNavIconExploreActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav-icon-explore-active",
    transform: "translate(-140 -320)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5669",
    "data-name": "Rectangle 5669",
    width: 34,
    height: 34,
    transform: "translate(140 320)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6980",
    "data-name": "Group 6980",
    transform: "translate(114.501 -144.711)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(2294 -297)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M27.071,350.508A10.674,10.674,0,1,1,16.4,339.834,10.674,10.674,0,0,1,27.071,350.508Z",
    transform: "translate(-2272.223 423.877)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M30.167,351.389a5.628,5.628,0,0,1,5.628,5.628",
    transform: "translate(-2285.994 417.368)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_8",
    "data-name": "Line 8",
    x2: 2.792,
    y2: 2.792,
    transform: "translate(-2248.477 782.123)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M52.521,390.782l4.451,4.451a2.306,2.306,0,1,0,3.261-3.261l-4.451-4.451a2.306,2.306,0,0,0-3.261,3.261Z",
    transform: "translate(-2298.206 397.394)",
    fill: "none",
    stroke: "#190a4e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIconExploreActive);
export default __webpack_public_path__ + "static/media/nav-icon-explore-active.6b61f85b0f7644bf82d4e7529f14526e.svg";
export { ForwardRef as ReactComponent };